// components
import React from 'react';
import ReactDOM from 'react-dom';

import ToastConfig from './../config/ToastDom';

/**
 * Config toastDom
 */
if( document.getElementById('toast-dom') ){
    ReactDOM.render(
        <ToastConfig/>
        , document.getElementById('toast-dom')
    );
}